module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Conformité des projets","text":"Suivez la progression des projets pour identifier les priorités et assurer une gestion optimale des tâches en cours.","link":"Consulter les tâches à faire"},"en":{"title":"Projects compliance","text":"Monitor the progress of projects to identify priorities and ensure optimal management of current tasks.","link":"View tasks to do"}}')
  delete Component.options._Ctor
}
